import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { site } from "@/mocks/site";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/clues", label: "线索归档" },
  { to: "/categories", label: "主题分类" },
  { to: "/faq", label: "常见问题" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 12);
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-6">
          <Link to="/" className="flex items-center gap-2.5 shrink-0">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-megaphone-line text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                {site.name}
              </span>
              <span className="mt-0.5 hidden text-[10px] font-label tracking-widest text-foreground-500 sm:block">
                匿名爆料 · 线索汇聚中心
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-label transition-colors ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/submit"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              我要爆料
            </Link>
            <button
              type="button"
              aria-label="打开菜单"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="flex flex-col px-4 py-3 md:px-8" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm font-label transition-colors ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/submit"
              className="mt-2 rounded-md bg-primary-500 px-3 py-3 text-center text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              我要爆料
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}

export default SiteHeader;